import { CONDITIONS_URL, PRIVACY_POLICY_URL } from '../../constants';

export const FOOTER_LINKS = [
    { text: 'Условия использования сервиса', href: CONDITIONS_URL },
    { text: 'Политика конфиденциальности', href: PRIVACY_POLICY_URL },
];
